import React from "react";

import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import {
  BookingCardLandscape,
  BookingCardPortrait,
  BookingCardClearingSale,
} from "components/Pdfs";

import { useSaleRoundRouteParams } from "hooks";
import { sortPenByOrder } from "lib/auctionPens";
import { BookingCardVersions, getPensByAgentId } from "lib/pdf";

import {
  getAuctionPensWithSaleLotsBySaleAndRound,
  currentSaleSelector,
  getOrganizationName,
  currentRoundSelector,
  selectDeploymentPlacardLogoUrlByDeploymentId,
  getCurrentSale,
  getSalePlacardLogo,
  getSaleLotsBySale,
} from "selectors";

function useBookingCardProps() {
  const match = useRouteMatch();
  const history = useHistory();
  const { agentId, version, saleRoundProps } = useSaleRoundRouteParams();

  const allAuctionPens = useSelector(state =>
    getAuctionPensWithSaleLotsBySaleAndRound(state, saleRoundProps),
  );
  const sortedPens = sortPenByOrder(allAuctionPens);
  const auctionPens = agentId
    ? getPensByAgentId(sortedPens, agentId)
    : allAuctionPens;

  const saleLots = useSelector(getSaleLotsBySale);
  const sale = useSelector(currentSaleSelector);
  const agencyName = useSelector(getOrganizationName);
  const round = useSelector(state =>
    currentRoundSelector(state, saleRoundProps),
  );

  const deploymentLogoLookup = useSelector(
    selectDeploymentPlacardLogoUrlByDeploymentId,
  );
  const currentSale = useSelector(getCurrentSale);
  const deploymentSale = currentSale.deployment_sales?.find(
    ds => ds.livestock_agency_id.toString() === agentId,
  );
  const deploymentId = deploymentSale?.deployment_id;
  const deploymentLogo = deploymentLogoLookup[deploymentId];

  const saleLogo = useSelector(getSalePlacardLogo);

  const extraSpacing =
    match.path.includes("bookingcardspacedlandscape") ||
    match.path.includes("bookingcardclearingsale") ||
    (match.path.includes("bookingcardspacedportrait") &&
      version !== BookingCardVersions.SignOffCompact);

  return {
    auctionPens,
    saleLots,
    sale,
    agencyName,
    round,
    extraSpacing,
    version,
    deploymentLogo,
    saleLogo,
    history,
  };
}

export const LandScape = () => {
  const props = useBookingCardProps();
  return <BookingCardLandscape {...props} />;
};

export const Portrait = () => {
  const props = useBookingCardProps();
  return <BookingCardPortrait {...props} />;
};

export const ClearingSale = () => {
  const props = useBookingCardProps();
  return <BookingCardClearingSale {...props} />;
};
